<template>
  <div class="__Dashboard-Announcements">
    <CTitle>{{ $t('Information') }}</CTitle>

    <AnnouncementList :data="getFilteredAnnouncementsLimit" dense />

    <div class="__Dashboard-Announcements-MoreInfo">
      <router-link to="announcements">{{ $t('See more') }}</router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CTitle from '@/components/uikit/CTitle';
import AnnouncementList from '@/pages/Announcements/AnnouncementList';

const messages = {
  en: {
    Information: 'Announcements',
    'See more': 'See more',
  },
  ja: {
    Information: 'お知らせ',
    'See more': 'もっと見る',
  },
};

export default Vue.extend({
  name: 'Announcements',
  i18n: { messages },
  components: { CTitle, AnnouncementList },
  computed: {
    ...mapGetters('announcements', ['getAllAnnouncements', 'getFilteredAnnouncementsLimit']),
  },
});
</script>

<style lang="scss" scoped>
.__Dashboard-Announcements {
  &-MoreInfo {
    font-size: $font-size-sm;
    padding-top: $space-xs;
    text-align: right;
  }
}
</style>
